import React from 'react';
import Util from '../Util';
import $ from 'jquery';
import Storage from '../Storage';

class SheldonKioskUpdater extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      path: '',
      content: '',
      args: '',
      useBeta: Storage.getSessionItem('SheldonKioskUpdater:useBeta'),
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleUseBetaClick(event) {
    const value = event.target.checked;
    this.setState({
      useBeta: value
    }, () => {
      Storage.setSessionItem("SheldonKioskUpdater:useBeta", value);
    });
  }

  toggleUseBetaClick() {
    const value = !this.state.useBeta;
    this.setState({
      useBeta: value
    }, () => {
      Storage.setSessionItem("SheldonKioskUpdater:useBeta", value);
    });
  }

  handleButtonClick(type, event) {
    event.preventDefault();

    let { ip } = this.props.hostInfo;
    let hostInfo = this.props.hostInfo;
    let { useBeta, args } = this.state;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let method = 'POST';
    let path = '';
    let dataType = 'text';
    let timeout = 90000;
    let wrapView = false;

    let linuxdash = Util.getLinuxDashPath(hostInfo);
    let script = useBeta ? 'kiosk-updater-beta.sh' : 'kiosk-updater.sh';
    args = args || '--help';

    switch (type) {
      case 'install-team-viewer':
        if (
          !window.confirm(
            'Make sure Team Viewer is not installed. Installation could take a few minutes. Continue?'
          )
        ) {
          return;
        }
        path =
          `${linuxdash}/exec/${script}?args=` +
          encodeURIComponent('--run-kiosk-script=install-team-viewer.sh');
        break;
      case 'update-scripts':
        if (!window.confirm('Update Scripts?')) {
          return;
        }
        path =
          `${linuxdash}/exec/${script}?args=` + encodeURIComponent('--update-scripts --no-log');
        break;
      case 'args':
        if (!window.confirm('Continue to run: "' + script + ' ' + args + '"?')) {
          return;
        }
        path = `${linuxdash}/exec/${script}?args=` + encodeURIComponent(args);
        break;
      case 'kiosk-stats':
        method = 'GET';
        path = `${linuxdash}/server?module=kiosk-stats`;
        break;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    return $.ajax({ url: path, dataType: dataType, method: method, timeout: timeout })
      .always(() => {
        this.inProgress = false;
      })
      .done((data) => {
        this.setState({
          content: wrapView ? <div>{data}</div> : <pre style={{ color: '' }}>{data}</pre>,
        });
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
        });
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { type, useBeta, args } = this.state;
    let script = useBeta ? 'kiosk-updater-beta.sh' : 'kiosk-updater.sh';

    return (
      <div className='sheldon-content-wrapper'>
        <h2>{useBeta ? 'kiosk-updater-beta.sh' : 'kiosk-updater.sh'}</h2>
        <div className='sheldon-buttons'>
          <button
            className={type === 'kiosk-stats' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'kiosk-stats')}
          >
            View Kiosk Stats
          </button>
          <button
            className={
              type === 'install-team-viewer' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'install-team-viewer')}
          >
            Install Team Viewer
          </button>
          <button
            className={
              type === 'update-scripts' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'update-scripts')}
          >
            Update Scripts
          </button>
        </div>
        <div style={{ textAlign: 'left', marginTop: 10 }}>
          <form className='pure-form' autoComplete='on' style={{ height: 58 }}>
            <fieldset>
              {script}{' '}
              <input
                className='pure-input-1-3'
                style={{ marginRight: 5 }}
                autoComplete='on'
                autoFocus={true}
                type='text'
                name='args'
                placeholder='--help'
                value={args}
                onChange={(event) => this.setState({ args: event.target.value })}
              />
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='submit'
                onClick={this.handleButtonClick.bind(this, 'args')}
              >
                Run
              </button>
              <div style={{ textAlign: 'left', marginLeft: 20, display: 'inline-block' }}>
                <a href='javascript:void(0)' onClick={this.toggleUseBetaClick.bind(this)}>
                  Use Beta Script:
                </a>
                <input
                  style={{ marginLeft: '5px' }}
                  name='useBeta'
                  type='checkbox'
                  checked={useBeta}
                  onChange={this.handleUseBetaClick.bind(this)}
                />
              </div>
            </fieldset>
          </form>
        </div>
        <div className='sheldon-content sheldon-cmd'>
          <div style={{ height: panelHeight - 300, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonKioskUpdater;



// WEBPACK FOOTER //
// ./src/components/SheldonKioskUpdater.js